import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfUse: React.FC = () => {
  return (
    <div className="min-h-screen bg-bg-primary text-text-primary" dir="rtl">
      {/* Header */}
      <header className="bg-bg-secondary py-6">
        <div className="container mx-auto px-4 sm:px-6 md:px-8 lg:px-16">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3">
              <img 
                src="/logos/10concept-logo.png"
                alt="10concept Logo"
                className="h-8 w-auto"
              />
              <span className="text-xl font-bold text-text-primary font-madani">10concept</span>
            </Link>
            <Link 
              to="/"
              className="text-text-secondary hover:text-primary transition-colors duration-300 font-madani"
            >
              العودة للرئيسية
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="py-12 md:py-16">
        <div className="container mx-auto px-4 sm:px-6 md:px-8 lg:px-16 max-w-4xl">
          <h1 className="text-3xl md:text-4xl font-black text-text-primary mb-8 font-madani">
            شروط الاستخدام
          </h1>
          
          <div className="prose prose-lg max-w-none text-text-secondary font-madani leading-relaxed">
            <p className="text-lg mb-6">
              مرحباً بك في موقع شركة 10concept (دار إبداع). يرجى قراءة هذه الشروط بعناية 
              قبل استخدام موقعنا أو خدماتنا. استخدامك لموقعنا يعني موافقتك على هذه الشروط.
            </p>

            <h2 className="text-2xl font-bold text-text-primary mt-8 mb-4 font-madani">
              1. قبول الشروط
            </h2>
            <p className="mb-6">
              باستخدامك لموقعنا أو خدماتنا، فإنك توافق على الالتزام بهذه الشروط والأحكام. 
              إذا كنت لا توافق على أي جزء من هذه الشروط، فيرجى عدم استخدام موقعنا.
            </p>

            <h2 className="text-2xl font-bold text-text-primary mt-8 mb-4 font-madani">
              2. وصف الخدمات
            </h2>
            <p className="mb-4">نحن نقدم:</p>
            <ul className="list-disc list-inside space-y-2 mb-6">
              <li>خدمات التصميم والإبداع</li>
              <li>تنظيم الأحداث والمؤتمرات (10event)</li>
              <li>الهدايا والمنتجات المبتكرة (10gift)</li>
              <li>المشاريع والمصانع المتطورة (10factory)</li>
              <li>خدمات استشارية في مجال الابتكار</li>
            </ul>

            <h2 className="text-2xl font-bold text-text-primary mt-8 mb-4 font-madani">
              3. استخدام الموقع
            </h2>
            <p className="mb-4">عند استخدام موقعنا، يتعين عليك:</p>
            <ul className="list-disc list-inside space-y-2 mb-6">
              <li>تقديم معلومات صحيحة ودقيقة</li>
              <li>عدم استخدام الموقع لأغراض غير قانونية</li>
              <li>عدم محاولة اختراق أو تعطيل الموقع</li>
              <li>احترام حقوق الملكية الفكرية</li>
              <li>عدم إرسال محتوى مسيء أو غير لائق</li>
            </ul>

            <h2 className="text-2xl font-bold text-text-primary mt-8 mb-4 font-madani">
              4. الملكية الفكرية
            </h2>
            <p className="mb-6">
              جميع المحتويات الموجودة على موقعنا، بما في ذلك النصوص والصور والشعارات 
              والتصاميم، محمية بحقوق الطبع والنشر وتعتبر ملكية لشركة 10concept أو 
              شركائها. لا يجوز نسخ أو استخدام هذه المحتويات دون إذن كتابي.
            </p>

            <h2 className="text-2xl font-bold text-text-primary mt-8 mb-4 font-madani">
              5. الخصوصية
            </h2>
            <p className="mb-6">
              نحن نحترم خصوصيتك ونلتزم بحماية معلوماتك الشخصية. يرجى مراجعة 
              <Link to="/privacy-policy" className="text-primary hover:underline"> سياسة الخصوصية</Link> 
              لفهم كيفية جمعنا واستخدامنا لمعلوماتك.
            </p>

            <h2 className="text-2xl font-bold text-text-primary mt-8 mb-4 font-madani">
              6. دقة المعلومات
            </h2>
            <p className="mb-6">
              نسعى جاهدين لضمان دقة المعلومات المقدمة على موقعنا، ولكن لا نضمن 
              دقة أو اكتمال جميع المعلومات. قد تحتوي المعلومات على أخطاء أو قد 
              تكون قديمة. نحن غير مسؤولين عن أي أضرار ناتجة عن الاعتماد على هذه المعلومات.
            </p>

            <h2 className="text-2xl font-bold text-text-primary mt-8 mb-4 font-madani">
              7. إخلاء المسؤولية
            </h2>
            <p className="mb-4">نحن غير مسؤولين عن:</p>
            <ul className="list-disc list-inside space-y-2 mb-6">
              <li>أي أضرار مباشرة أو غير مباشرة</li>
              <li>فقدان البيانات أو الأرباح</li>
              <li>انقطاع الخدمة أو عدم توفرها</li>
              <li>أي أضرار ناتجة عن استخدام أطراف ثالثة</li>
            </ul>

            <h2 className="text-2xl font-bold text-text-primary mt-8 mb-4 font-madani">
              8. التعديلات
            </h2>
            <p className="mb-6">
              نحتفظ بالحق في تعديل هذه الشروط في أي وقت دون إشعار مسبق. 
              استمرار استخدامك للموقع بعد التعديلات يعني موافقتك على الشروط الجديدة.
            </p>

            <h2 className="text-2xl font-bold text-text-primary mt-8 mb-4 font-madani">
              9. القانون الحاكم
            </h2>
            <p className="mb-6">
              تخضع هذه الشروط وتفسر وفقاً لقوانين المملكة العربية السعودية. 
              أي نزاعات تنشأ عن هذه الشروط تخضع للاختصاص الحصري للمحاكم السعودية.
            </p>

            <h2 className="text-2xl font-bold text-text-primary mt-8 mb-4 font-madani">
              10. التواصل معنا
            </h2>
            <p className="mb-6">
              إذا كان لديك أي أسئلة حول هذه الشروط، يرجى التواصل معنا عبر:
            </p>
            <div className="bg-bg-secondary p-6 rounded-lg">
              <p className="mb-2"><strong>البريد الإلكتروني:</strong> info@10concept.sa</p>
              <p className="mb-2"><strong>الهاتف:</strong> +966580731010</p>
              <p><strong>العنوان:</strong> الرياض، المملكة العربية السعودية</p>
            </div>

            <div className="mt-8 pt-6 border-t border-gray-700">
              <p className="text-sm text-text-secondary">
                آخر تحديث: {new Date().toLocaleDateString('ar-SA')}
              </p>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-bg-secondary py-8 mt-16">
        <div className="container mx-auto px-4 sm:px-6 md:px-8 lg:px-16 text-center">
          <p className="text-text-secondary text-sm font-madani">
            © {new Date().getFullYear()} 10concept. جميع الحقوق محفوظة.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default TermsOfUse;
